module.exports = __webpack_public_path__ + "static/media/step1.15e7753a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/tbank/step1.jpg
// module id = 710
// module chunks = 0